// DonutChart.js
import React, { useRef, useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
  Tooltip,
  Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
  Tooltip,
  Legend
);

const LineChart = ({ weekActivitData }) => {
  const chartRef = useRef(null);
  const [gradient, setGradient] = useState(null);

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.ctx;
      const gradientFill = ctx.createLinearGradient(0, 0, 0, ctx.canvas.height);
      gradientFill.addColorStop(0.0683, 'rgba(168, 106, 219, 0.4225)');
      gradientFill.addColorStop(0.7688, 'rgba(168, 106, 219, 0)');
      setGradient(gradientFill);
    }
  }, []);

  const valueY = [];
  const valueX = [];
  weekActivitData?.map((data) => {
    valueY.push(data.y);
    valueX.push(data.x);
  })

  const data = {
    labels: valueX?.length > 0 ? valueX : ['1', '2', '3', '4'],
    datasets: [
      {
        label: 'Minutes Watched',
        data: valueY,
        fill: true,
        backgroundColor: gradient,
        borderColor: '#B679E2',
        tension: 0.5,
        pointRadius: 0,
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
      x: {
        grid: {
          display: true,
          color: '#e0e0e0',
          drawTicks: false,
        },
        title: {
          display: true,
          text: 'Weeks',
          font: {
            size: 14
          }
        },
        ticks: {
          font: {
            size: 12,
          }
        }
      },
      y: {
        grid: {
          display: false,
        },
        min: 0,
        max: 120,
        title: {
          display: true,
          text: 'Minutes Watched',
          font: {
            size: 14
          }
        },
        ticks: {
          stepSize: 10,
          font: {
            size: 12,
          }
        }
      },
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: true
      },
    },
  };

  return (
    <div style={{ margin: 'auto' }}>
      <Line ref={chartRef} data={data} options={options} />
    </div>
  );
};

export default LineChart;